
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"65","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 12.75h-5a5 5 0 00-5 5v5m10-10h20m-20 0v10m0 30h-5a5 5 0 01-5-5v-5m10 10h20m-20 0v-10m20-30h5a5 5 0 015 5v5m-10-10v10m0 30h5a5 5 0 005-5v-5m-10 10v-10m10-10H42m10 0v-10m0 10v10m-10-10v-10m0 10v10m0-10H22m0 0H12m10 0v-10m0 10v10m-10-10v-10m0 10v10m10-20H12m30 0h10m0 20H42m-20 0H12","stroke":"#748190","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    